import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Divider } from 'ui-components/components/divider/divider';
import { FlexColumn } from 'ui-components/components/flex';

import style from './read-only-rate-card.module.less';
import { CurrencyPropType } from '../../../../prop-types/currency';
import { RateCardSection } from '../section/rate-card-section';
import VoidedLabelExpander from '../voided/voided-label-expander';
import LabelDetails from './label-details/label-details';
import ServiceDetails from './service-details/service-details';

const ReadOnlyRateCard = ({
  carrierId,
  deliveryDate,
  delegationDateTime,
  fillProviderId,
  hasProvidedRate = false,
  isLocalDelivery = false,
  isMarkAsShipped = false,
  isThirdPartyBilling = false,
  labelDetailsActions,
  labelProviderId,
  pickupDate,
  serviceName,
  shipDate,
  totalCost,
  trackingNumber,
  trackingUrl,
  voidedFulfillments,
}) => {
  return (
    <RateCardSection>
      <FlexColumn className={style['details-container']}>
        <LabelDetails
          actionMenuItems={labelDetailsActions}
          carrierId={carrierId}
          fillProviderId={fillProviderId}
          isMarkAsShipped={isMarkAsShipped}
          labelProviderId={labelProviderId}
          serviceName={serviceName}
          trackingNumber={trackingNumber}
          trackingUrl={trackingUrl}
        />
        <Divider />
        <ServiceDetails
          delegationDateTime={delegationDateTime}
          deliveryDateTime={deliveryDate}
          hasProvidedRate={hasProvidedRate}
          isPickupServiceSelected={isLocalDelivery}
          isThirdPartyBilling={isThirdPartyBilling}
          labelCost={totalCost}
          pickupDateTime={pickupDate}
          shipDate={shipDate}
        />
      </FlexColumn>
      {voidedFulfillments?.length > 0 && (
        <VoidedLabelExpander className={style['voided-label-expander']} voidedFulfillments={voidedFulfillments} />
      )}
    </RateCardSection>
  );
};

export default memo(ReadOnlyRateCard);

ReadOnlyRateCard.propTypes = {
  deliveryDate: PropTypes.string,
  hasProvidedRate: PropTypes.bool,
  isLocalDelivery: PropTypes.bool,
  isThirdPartyBilling: PropTypes.bool,
  labelProviderId: PropTypes.string,
  fillProviderId: PropTypes.string,
  pickupDate: PropTypes.string,
  delegationDateTime: PropTypes.string,
  serviceName: PropTypes.string,
  shipDate: PropTypes.string,
  totalCost: CurrencyPropType,
  trackingNumber: PropTypes.string,
  trackingUrl: PropTypes.string,
  voidedFulfillments: PropTypes.arrayOf(PropTypes.object),
  isMarkAsShipped: PropTypes.bool,
  carrierId: PropTypes.string,
  labelDetailsActions: PropTypes.node,
};
